import { IList } from 'annotation-tools/utils';
import { IBboxType, IdType } from '../imports/annotation-canvas';
import {
  IRectType,
  useEventAsStream,
  useVoidEventAsStream
} from '../imports/utils';
import { AppMode } from '../types/enum/app-mode';
import { ToolbarButtonIdEnum } from '../types/enum/toolbar-button-id-enum';

export const useEventStreams = () => {
  const [appModeChange$, onAppModeChange] = useEventAsStream<AppMode>();

  const [
    // dummy comment to control prettier
    toolbarButtonClick$,
    onToolbarButtonClick
  ] = useEventAsStream<ToolbarButtonIdEnum>();

  const [pageChange$, onPageChange] = useEventAsStream<number>();

  const [labelClick$, onLabelClick] = useEventAsStream<IdType>();

  const [visibilityClick$, onVisibilityClick] = useEventAsStream<IdType>();

  const [showAllClick$, onShowAllClick] = useVoidEventAsStream();
  const [hideAllClick$, onHideAllClick] = useVoidEventAsStream();

  const [closeHelpDialog$, closeHelpDialog] = useVoidEventAsStream();

  const [
    // dummy comment to control prettier
    confirmDialogResult$,
    closeConfirmDialog
  ] = useEventAsStream<'yes' | 'no'>();

  const [
    bboxesFromCanvasRelativeToImage$,
    onBboxesFromCanvasRelativeToImageChange
  ] = useEventAsStream<IList<IBboxType>>();

  const [
    cropRectRelativeFromCanvas$,
    onCropRectRelativeChange
  ] = useEventAsStream<IRectType>();

  return {
    appModeChange$,
    onAppModeChange,
    /* button on click */
    toolbarButtonClick$,
    onToolbarButtonClick,
    pageChange$,
    onPageChange,
    labelClick$,
    onLabelClick,
    /* labels */
    visibilityClick$,
    onVisibilityClick,
    showAllClick$,
    onShowAllClick,
    hideAllClick$,
    onHideAllClick,
    /* dialogs */
    closeHelpDialog$,
    closeHelpDialog,
    confirmDialogResult$,
    closeConfirmDialog,
    /* annotation */
    bboxesFromCanvasRelativeToImage$,
    onBboxesFromCanvasRelativeToImageChange,
    /* crop */
    cropRectRelativeFromCanvas$,
    onCropRectRelativeChange
  };
};
